<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12" sm="10" md="8" lg="6" xl="4">
        <v-card class="my-5">
          <v-card-title> Your Data and Privacy </v-card-title>
          <v-divider />
          <v-card-text class="body-1">
            Your information and privacy is of great concern and is strongly
            secured in Google's firebase servers behind MFA (multi-factor
            authentication). Whenever share your data and don't have access to
            important things like your password. Rest assured, the data you
            trust us with will be kept safe and we are thankful for that.
            <ul class="data-list">
              <li>
                <strong>Basic account information</strong> for identification
                (<strong>name</strong>, <strong>title</strong>, and
                <strong>email</strong>) these are entered at signup
              </li>
              <li>
                Your <strong>account settings</strong> that you change so they
                can be saved for next time you login.
              </li>
              <li>
                The <strong>todos that you make</strong>, keep in mind these are
                private to you only.
              </li>
            </ul>
            <span
              >Keep in mind all of this data is never shared, copied, or
              modified in any way. We don't sell, compile, or analyze anything
              you do on this site beyond the basic necessary UI functions.
            </span>
          </v-card-text>
        </v-card>
        <v-card v-for="(item, i) in items" :key="i" class="my-5">
          <v-card-title>
            {{ item.title }}
          </v-card-title>
          <v-divider />
          <v-card-text class="body-1">
            {{ item.body }}
          </v-card-text>
        </v-card>
        <span class="title"></span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'About',
  data: () => ({
    items: [
      {
        title: 'The Purpose',
        body: 'I wanted to make a new simple todo app that lacked the complexity of previous todo apps that get in the way of you and your work.',
      },
      {
        title: 'Starred, Completed, and Deleted',
        body: 'Although it may seem limiting at first, I created these three lists with the idea that they can contain everything that you need to do. Often times with multiple lists, things get lost and confused, make it harder to focus on your work. There is one thing in common with all todos, they all need to be done. Some will be more important than others (starred), todos will be completed, and discarded.',
      },
      {
        title: 'Who is this for?',
        body: "This is for people who like simplicity, don't want complex calendar functionality that often conflicts with other calendars and general clutter. If anything is serious or time sensitive, just put it in your calendar. Otherwise keep it here, this way you can still use your calendar and this app without feeling like you are missing out on one over the other when you have both!",
      },
      {
        title: 'Developer',
        body: 'My name is David Hanft, you can find me on Github (@Aero-blue).',
      },
      {
        title: 'Support / Contact',
        body:
          '              While I am quite busy and am a solo developer, I am always happy\n' +
          '              to help anyone with anything. Just send mea an email at\n' +
          '              aero_blue@outlook.com and I will see what I can do!',
      },
    ],
  }),
}
</script>

<style scoped>
.data-list li {
  padding-top: 0.5em;
  padding-bottom: 0.5em;
}

.data-list {
  padding-top: 0.7em;
  padding-bottom: 0.7em;
}
</style>
